import React from "react";

function ShopCardMeta({ shop }) {
  if (!shop) {
    return null;
  }

  const openLeads = Number(shop.crm_open_leads_count || 0);
  const hasCrmBadge = openLeads > 0;
  const hasSlaBadge = Boolean(shop.crm_sla_breached);
  const hasCreditLabel = Boolean(shop.remaining_credit_label);
  const daysRemaining = shop.credit_days_remaining;
  const hasDaysLine =
    daysRemaining !== null && daysRemaining !== undefined && !Number.isNaN(Number(daysRemaining));

  if (!hasCrmBadge && !hasSlaBadge && !hasCreditLabel && !hasDaysLine) {
    return null;
  }

  return (
    <div className="shop-card-meta">
      {(hasCrmBadge || hasSlaBadge) && (
        <div className="shop-card-badges">
          {hasCrmBadge && (
            <span className="shop-card-badge shop-card-badge-crm">
              {openLeads} سرنخ باز
            </span>
          )}
          {hasSlaBadge && (
            <span className="shop-card-badge shop-card-badge-sla">نقض SLA</span>
          )}
        </div>
      )}
      {(hasCreditLabel || hasDaysLine) && (
        <div className="shop-card-meta-lines">
          {hasCreditLabel && (
            <span className="shop-card-meta-line">
              اعتبار باقی‌مانده: {shop.remaining_credit_label}
            </span>
          )}
          {hasDaysLine && (
            <span
              className={`shop-card-meta-line${
                Number(daysRemaining) <= 0 ? " is-warning" : ""
              }`}
            >
              {Number(daysRemaining) > 0
                ? `${daysRemaining} روز مانده`
                : "اعتبار روزانه منقضی"}
            </span>
          )}
        </div>
      )}
    </div>
  );
}

export default React.memo(ShopCardMeta);
